import type {
  DocumentTypeInfoModel,
  DocumentTypeInfoViewModel,
} from "@models/doctype";

export const buildDocumentTypesInfoViewModel = (
  response: DocumentTypeInfoModel[],
): DocumentTypeInfoViewModel[] => {
  return response.map((doctype) => ({
    docTypeCode: doctype.doctype_code,
    docTypeName: doctype.doctype_name,
    logoUrl: doctype.logo_url ?? null,
    description: doctype.description ?? null,
    categoryName: doctype.category_name ?? null,
    categoryDescription: doctype.category_description ?? null,
    sharepointEnabled: doctype.sharepoint_enabled ?? false,
    mappingConfig: doctype.mapping_config
      ? {
          enabled: doctype.mapping_config.enabled,
          service: doctype.mapping_config.service ?? null,
          pluginId: doctype.mapping_config.plugin_id ?? null,
        }
      : null,
  }));
};
